<template>
    <div class="permissions">
        <h4 class="authorize-context">
            {{prompt}}
        </h4>
        <div class="portal-auth-settings-allowed">
            <ul>
                <li v-for="(scope,index) in englishScopes" :key="index">
                    <i class="fa fa-check-circle permission_tick"/>
                    <span style="font-size: 18px;">
                        {{scope}}
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import MapScopesToEnglish from '../../utils/MapScopesToEnglish.js';

    export default {
        methods: {
            combineScope: (scope1, scope2, combinedScope, allScopes) => {
                if (allScopes.indexOf(scope1) > -1 && allScopes.indexOf(scope2) > -1) {
                    allScopes.splice(allScopes.indexOf(scope1), 1);
                    allScopes.splice(allScopes.indexOf(scope2), 1);
                    allScopes.push(combinedScope)
                }
            },
        },
        computed: {
            englishScopes() {
                const scopes = this.$store.state.scopes;
                this.combineScope('lo.read', 'lo.write', 'lo.all', scopes);
                this.combineScope('portal.read', 'portal.write', 'portal.all', scopes);
                this.combineScope('enrollment.read', 'enrollment.write', 'enrollment.all', scopes);
                this.combineScope('group.read', 'group.write', 'group.all', scopes);
                this.combineScope('app.read', 'app.write', 'app.all', scopes);
                this.combineScope('webhook.read', 'webhook.write', 'webhook.all', scopes);
                this.combineScope('user.read', 'user.write', 'user.all', scopes);
                this.combineScope('account.read', 'openid', 'account.read', scopes);
                return MapScopesToEnglish(scopes)
            },
            prompt() {
                return window.authConfig && window.authConfig.referrer ?
                    `Allow ${window.authConfig.referrer} to access:` :
                    'Authorize access to:';
            }
        }
    }
</script>

<style scoped>
    .permission_tick {
        color: #317481;
        font-size: 25px;
        margin-right: 5px;
    }

    .authorize-context {
        font-size: 16px;
        line-height: 22px;
        text-align: left;
        color: #666F71;
        font-weight: 400;
    }

    .portal-auth-settings-allowed {
        border-radius: 10px;
        padding: 0;
        width: 400px;
    }

    .portal-auth-settings-allowed ul {
        list-style-type: none;
        text-align: left;
        padding: 0;
    }

    .portal-auth-settings-allowed li {
        display: flex;
        margin-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auth/Permissions.vue